export default "__VITE_ASSET__CyS7NQwY__"